import { AlertTriangle, Inbox, Loader2, RefreshCw } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

export const inputCls =
  'w-full rounded-xl border border-white/15 bg-white/[0.05] px-4 py-3 text-sm text-white placeholder:text-slate-600 outline-none focus:border-krug-tealbright transition-colors duration-300';

export const fmtDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString('bs-BA');
};

export const fmtCell = (key, value, yesLabel = 'Da', noLabel = 'Ne') => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? yesLabel : noLabel;
  if (typeof value === 'object') return JSON.stringify(value);
  if (typeof value === 'string' && /(_at|date|time)$/.test(key) && !Number.isNaN(Date.parse(value))) return fmtDate(value);
  return String(value);
};

export const asList = (data, keys) => {
  if (Array.isArray(data)) return data;
  for (const k of keys) if (Array.isArray(data?.[k])) return data[k];
  return [];
};

export const labelFor = (key, fields) => fields[key] || key.replace(/_/g, ' ');

export const LoadingBox = ({ text, testid }) => (
  <p data-testid={testid} className="rounded-2xl glass-dark px-6 py-10 text-center text-sm text-slate-500">
    <Loader2 size={18} className="mx-auto animate-spin text-krug-tealbright" />
    <span className="mt-3 block">{text}</span>
  </p>
);

export const ErrorBox = ({ text, retryText, onRetry, testid }) => (
  <div data-testid={testid} className="rounded-2xl glass-dark px-6 py-10 text-center">
    <AlertTriangle size={22} className="mx-auto text-slate-600" />
    <p className="mt-3 text-sm text-slate-500">{text}</p>
    <button
      type="button"
      data-testid={`${testid}-retry`}
      onClick={onRetry}
      className="mt-4 rounded-full bg-krug-teal px-5 py-2.5 text-xs font-bold text-white hover:bg-krug-tealbright hover:text-krug-navy transition-colors duration-300"
    >
      {retryText}
    </button>
  </div>
);

export const EmptyBox = ({ text, testid }) => (
  <p data-testid={testid} className="rounded-2xl glass-dark px-6 py-10 text-center text-sm text-slate-500">
    <Inbox size={20} className="mx-auto mb-3 text-slate-600" />
    {text}
  </p>
);

export const TabHeader = ({ icon: Icon, title, count, onRefresh, refreshLabel, testid, children }) => (
  <div className="flex flex-wrap items-center justify-between gap-4">
    <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-white flex items-center gap-3">
      <Icon size={24} className="text-krug-tealbright" />
      {title}
      {typeof count === 'number' && <span className="text-sm font-bold text-krug-goldbright">({count})</span>}
    </h2>
    <div className="flex flex-wrap items-center gap-3">
      {children}
      <button
        type="button"
        data-testid={`${testid}-refresh`}
        onClick={onRefresh}
        className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-bold text-slate-300 hover:text-white hover:border-krug-gold/50 transition-colors duration-300"
      >
        <RefreshCw size={13} />
        {refreshLabel}
      </button>
    </div>
  </div>
);
